import request from "../request";

export default {
	
	//主体-列表-全部
	listsAll(data) {
		return request.get("/adminSubject/listsAll", data);
	},
	
	//主体-列表
	lists(data) {
		return request.get("/adminSubject/lists", data);
	},
	
	//主体-添加
	add(data) {
		return request.post("/adminSubject/add", data);
	},
	
	//主体-修改
	edit(data) {
		return request.post("/adminSubject/edit", data);
	},
	
	//主体-删除
	delete(data) {
		return request.post("/adminSubject/delete", data);
	},
	
	//主体-信息
	info(data) {
		return request.get("/subject/info", data);
	},
	
	
	
};
